/**
 * Hamburger Menu JS
 */

jQuery(document).ready(function($) {
	$(".hamburger").click(function(){
 		$(this).toggleClass("is-active");
 	});

	$(".hamburger-close").click(function(){
		$(".hamburger").removeClass("is-active");
	});
	$(".js-off-canvas-overlay").click(function(){
		$(".hamburger").removeClass("is-active");
	});
});